// @vendors
const { connect } = require('react-redux');
// @actions
const chatActions = require('actions/chat');
// @components
const Chat = require('./Chat');

const mapStateToProps = (state) => ({
    chatWindowStatus: state.okChat.get('chatWindowStatus'),
    conversationStatus: state.okChat.get('conversationStatus'),
    chatAvailabilityStatusData: state.okChat.get('chatAvailabilityStatusData'),
    isChatAvailable: state.okChat.get('isChatAvailable'),
    msgReceiveFail : state.okChat.get('msgReceiveFail'),
    retrieveMessagesInterval: state.okChat.getIn(['options', 'messagesRefreshInterval'], null),
    timer: state.okChat.get('timer')
});

const mapDispatchToProps = ({
    chatAvailabilityStatus: chatActions.chatAvailabilityStatus,
    endConversation: chatActions.endConversation,
    retrieveMessages: chatActions.retrieveMessages,
    retrieveMessagesHistory:chatActions.retrieveMessagesHistory,
    resetTimer: chatActions.resetTimer,
    setTimer: chatActions.setTimer,
    startConversation: chatActions.startConversation,
    toggleWindow: chatActions.toggleWindow
});

const ChatContainer = connect(mapStateToProps, mapDispatchToProps)(Chat);

module.exports = ChatContainer;
